import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { toast } from 'react-toastify';
import api from '../utils/api';

export const heroBannerThunk = createAsyncThunk(
    'banner/Herobanner',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.addHeroBanner(config);
            toast.success('herobanner added successfully')
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error('error of adding banner')
        }
    }
);


export const getHeroBannerThunk = createAsyncThunk(
    'banner/getHeroBanner',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getBanner(config);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const sliderThunk = createAsyncThunk(
    'slider/sliderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.addSlider(config);
            toast.success('sliders added successfully')
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error('error of adding sliders')
        }
    }
);

export const getSliders = createAsyncThunk(
    'sliders/getSliders',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getSlider(config);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);


export const addLoginBuilderThunk = createAsyncThunk(
    'loginbanner/addLoginBuilderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.addLoginBuilder(config);
            toast.success('Login Builder added successfully')
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error('error of adding Login Builder')
        }
    }
);

export const addTopcategoriesThunk = createAsyncThunk(
    'categories/topcategories',
    async (config, { rejectWithValue ,dispatch}) => {
        try {
            const response = await api.addTopCategories(config);
            dispatch(setAppearenceRefresh())

            toast.success('categories added successfully')
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error('error of adding categories')
        }
    }
);

export const addTopProductsThunk = createAsyncThunk(
    'products/addTopproducts',
    async (data, { rejectWithValue ,dispatch}) => {
        try {
            const response = await api.addTopProducts(data);
            await dispatch(getTopProductThunk());
            toast.success('products added successfully')
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message||'error of adding products')
        }
    }
);

export const deleteTopProductsThunk = createAsyncThunk(
    'products/deleteTopProducts',
    async (productnumber, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.deleteTopProducts(productnumber);
            await dispatch(getTopProductThunk());
            toast.success('popular product title deleted successfully');
            return response.data;
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'error of deleting popular product title');
            return rejectWithValue(error?.response?.data);
        }
    }
);

export const getLoginBuilderThunk = createAsyncThunk(
    'loginBuilder/getLoginBuilderThunk',
    async (config, { rejectWithValue }) => {
        try {
            const response = await api.getLoginBuilder(config);

            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getTopCategoriesThunk = createAsyncThunk(
    'categories/gettopcategories',
    async (config, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getTopCategories(config);
          
            return response.data?.data?.categories;
        } catch (error) {
            console.log(error);
        }
    }
);

export const getTopProductThunk = createAsyncThunk(
    'products/getTopProductThunk',
    async (config, { rejectWithValue, dispatch }) => {
        try {
            const response = await api.getTopProducts(config);
          
            return response.data?.data;
        } catch (error) {
            console.log(error);
        }
    }
);

// Slice for categories
const appearenceSlice = createSlice({
    name: 'appearance',
    initialState: {
        heroBannerData: {
            data: {},
            loading: false
        },
        sliders: {
            data: [],
            loading: false
        },
        categories: {
            data: [],
            loading: false
        },
        login:{
            data:{},
            loading:false
        },
        topproduct:{
           data:{},
           loading:false
        },
        loading: false,
        refresh: false
    },
    reducers: {
        setAppearenceRefresh: (state, action) => {
            state.refresh = !state.refresh
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(sliderThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sliderThunk.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sliderThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getHeroBannerThunk.pending, (state) => {
                state.heroBannerData.loading = true;

            })
            .addCase(getHeroBannerThunk.fulfilled, (state, action) => {
                state.heroBannerData.loading = false;
                state.heroBannerData.data = action.payload
            })
            .addCase(getHeroBannerThunk.rejected, (state, action) => {
                state.heroBannerData.loading = false;

            })
            .addCase(getSliders.pending, (state) => {
                state.sliders.loading = true;
            })
            .addCase(getSliders.fulfilled, (state, action) => {
                state.sliders.loading = false;
                state.sliders.data = action.payload
            })
            .addCase(getSliders.rejected, (state, action) => {
                state.sliders.loading = false;
            })

            .addCase(addTopcategoriesThunk.pending, (state) => {
                state.categories.loading = true;
            })
            .addCase(addTopcategoriesThunk.fulfilled, (state, action) => {
                state.categories.loading = false;
            })
            .addCase(addTopcategoriesThunk.rejected, (state, action) => {
                state.categories.loading = false;
            })

            .addCase(getTopCategoriesThunk.pending, (state) => {
                state.categories.loading = true;
            })
            .addCase(getTopCategoriesThunk.fulfilled, (state, action) => {
                state.categories.loading = false;
                state.categories.data = action.payload
            })
            .addCase(getTopCategoriesThunk.rejected, (state, action) => {
                state.categories.loading = false;
            })

            .addCase(getLoginBuilderThunk.pending, (state) => {
                state.login.loading = true;
            })
            .addCase(getLoginBuilderThunk.fulfilled, (state, action) => {
                state.login.loading = false;
                state.login.data = action.payload
            })
            .addCase(getLoginBuilderThunk.rejected, (state, action) => {
                state.login.loading = false;
            })

            .addCase(getTopProductThunk.pending, (state) => {
                state.topproduct.loading = true;
            })
            .addCase(getTopProductThunk.fulfilled, (state, action) => {
                state.topproduct.loading = false;
                state.topproduct.data = action.payload
            })
            .addCase(getTopProductThunk.rejected, (state, action) => {
                state.topproduct.loading = false;
            })
    },
});

export const { setvendorEdit, setvendorRefresh, setVendorPage, setAppearenceRefresh } = appearenceSlice.actions

export default appearenceSlice.reducer;

